import { create } from 'zustand';

interface CompareState {
  isOpen: boolean;
  selectedPlans: string[];
  comparisonLimit: number;
  compareViewCategory: string | null;
  open: () => void;
  close: () => void;
  togglePlan: (planId: string) => void;
  removePlan: (planId: string) => void;
  clearPlans: () => void;
  clearSelectedPlans: () => void;
  setComparisonLimit: (limit: number) => void;
  setSelectedPlans: (plans: string[]) => void;
  setCompareViewCategory: (category: string | null) => void;
  handleSelectCompare: (planId: string, currentPlansToCompare: string[], limit?: number) => string[];
}

export const useCompareStore = create<CompareState>((set, get) => ({
  isOpen: false,
  selectedPlans: [],
  comparisonLimit: 3,
  compareViewCategory: null,
  open: () => {
    set({ isOpen: true });
  },
  close: () => set({ isOpen: false }),
  togglePlan: (planId: string) => {
    const { selectedPlans, comparisonLimit } = get();
    const isSelected = selectedPlans.includes(planId);

    if (isSelected) {
      // Remove plan from comparison
      set({ selectedPlans: selectedPlans.filter(id => id !== planId) });
    } else {
      // Add plan to comparison if under limit
      if (selectedPlans.length < comparisonLimit) {
        set({ selectedPlans: [...selectedPlans, planId] });
      }
    }
  },
  removePlan: (planId: string) => {
    const { selectedPlans } = get();
    set({ selectedPlans: selectedPlans.filter(id => id !== planId) });
  },
  clearPlans: () => set({ selectedPlans: [] }),
  clearSelectedPlans: () => set({ selectedPlans: [] }),
  setComparisonLimit: (limit: number) => set({ comparisonLimit: limit }),
  setSelectedPlans: (plans: string[]) => set({ selectedPlans: plans }),
  setCompareViewCategory: (compareViewCategory: string | null) => set({ compareViewCategory }),
  
  // Централизованная логика для handleSelectCompare
  handleSelectCompare: (planId: string, currentPlansToCompare: string[], limit?: number) => {
    const { comparisonLimit } = get();
    const actualLimit = limit || comparisonLimit;
    
    const updatedPlansToCompare = currentPlansToCompare.includes(planId)
      ? currentPlansToCompare.filter((plan) => plan !== planId)
      : [...currentPlansToCompare, planId];

    if (updatedPlansToCompare.length > actualLimit) {
      return currentPlansToCompare; // Возвращаем без изменений если превышен лимит
    }
    
    // Обновляем внутреннее состояние store
    set({ selectedPlans: updatedPlansToCompare });
    
    return updatedPlansToCompare;
  },
}));


